import React from 'react';

import ObjectListView from '../ObjectListView.js';
import SelectInput from '../input/SelectInput.js';
import CheckboxInput from '../input/CheckboxInput.js';
import SwitchInput from '../input/SwitchInput.js';
import DateInput from '../input/DateInput.js';
import WysiwygInput from '../input/WysiwygInput.js';
import TextInput from '../input/TextInput.js';
import JsonInput from '../input/JsonInput.js';
import FileInput from '../input/FileInput.js';
import FileUploadInput from '../input/FileUploadInput.js';
import FileMultiUploadInput from '../input/FileMultiUploadInput.js';
import LinkInput from '../input/LinkInput.js';
import PageLink from '../input/PageLink.js';
import ImageInput from '../input/ImageInput.js';
import TodoList from '../input/TodoList.js';
import LinksList from '../input/LinksList.js';
import DetailedSelectInput from '../input/DetailedSelectInput.js';
import AdditionalButtons from '../input/AdditionalButtons.js';
import ChangesInput from '../input/ChangesInput.js';
import ObjectInput from '../input/ObjectInput.js';

import UserAvatarView from '../UserAvatarView';

export default class FlexibleInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    const properties = this.props.properties;
    switch (properties.type) {
      case "object-list":
        const { properties, ...props } = this.props;
        return <ObjectListView
          embedded
          configKey={properties.configKey}
          config={properties.config}
          properties={properties.properties}
          {...props}
        />
      case "text":
      case "number":
      case "password":
      case "textarea":
        return <TextInput {...this.props} />
      case "wysiwyg":
        return <WysiwygInput {...this.props} />
      case "select":
      case "multi-select":
        return <SelectInput {...this.props} />
      case "checkbox":
        return <CheckboxInput {...this.props} />
      case "switch":
        return <SwitchInput {...this.props} />
      case "date":
      case "datetime":
      case "month":
        return <DateInput {...this.props} />
      case "file":
        return <FileInput {...this.props} />
      case "file-upload":
        return <FileUploadInput {...this.props} />
      case "file-multi-upload":
        return <FileMultiUploadInput {...this.props} />
      case "link":
        return <LinkInput {...this.props} />
      case "json":
        return <JsonInput {...this.props} />
      case "avatar":
        return <UserAvatarView {...this.props} />
      case "page-link":
        return <PageLink {...this.props} />
      case "image":
        return <ImageInput {...this.props} />
      case "todo-list":
        return <TodoList {...this.props} />
      case "links-list":
        return <LinksList {...this.props} />
      case "detailed-select":
        return <DetailedSelectInput {...this.props} />
      case "additional-buttons":
        return <AdditionalButtons {...this.props} />
      case "changes":
        return <ChangesInput {...this.props} />
      case "object":
        return <ObjectInput {...this.props} />
      default:
        return null;
    }
  }
}
